<template>
  <div>
    <el-form size="small" ref="formRef" :model="formData" :rules="rules" label-width="80px" style="padding: 20px">
      <el-col :span="12">
        <el-form-item label="客户姓名" prop="name" :error="errMsg.name">
          <el-input v-model="formData.name" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="id_card" :error="errMsg.id_card">
          <el-input v-model="formData.id_card" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone" :error="errMsg.phone">
          <el-input v-model="formData.phone" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="客户标签" prop="customer_tag" :error="errMsg.customer_tag">
          <customer-tag v-model="formData.customer_tag" style="width: 250px" :disabled="isView"></customer-tag>
        </el-form-item>
        <el-form-item label="业务员" prop="employee_id" :error="errMsg.employee_id">
          <employee-select v-model="formData.employee_id" style="width: 250px" :disabled="isView"></employee-select>
        </el-form-item>
        <el-form-item label="成交" prop="is_succ" :error="errMsg.is_succ">
          <el-select v-model="formData.is_succ" placeholder="请选择" style="width: 250px" :disabled="isView">
            <el-option label="未成交" :value="0"></el-option>
            <el-option label="待成交" :value="1"></el-option>
            <el-option label="已成交" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成交日期" prop="succ_date" :error="errMsg.succ_date" v-if="formData.is_succ == 2">
          <el-date-picker v-model="formData.succ_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="isView"> </el-date-picker>
        </el-form-item>
        <el-form-item label="附件" prop="fileList" :error="errMsg.fileList">
          <div style="width: 230px; display: flex; flex-wrap: wrap; gap: 5px">
            <div class="thumbnail-container" v-for="(item, index) in formData.fileList" :key="index">
              <el-image class="image" :src="item.url" v-if="item.types == 'img'"> </el-image>
              <el-card shadow="never" :body-style="{ padding: '0px' }" class="att" v-else><i class="el-icon-paperclip icon"></i></el-card>
              <div class="action-buttons">
                <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview({ url: item.url })" v-if="item.types == 'img'"></i>
                <i class="el-icon-download icon" @click="handleDownload(item.url)"></i>
                <i class="el-icon-delete icon" @click="handleRemove(index)" v-if="!isView"></i>
              </div>
            </div>
            <uploads @change="handleChange" v-if="!isView"></uploads>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="企业名称" prop="company_name" :error="errMsg.company_name">
          <el-input v-model="formData.company_name" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="对公户" prop="corporate_account" :error="errMsg.corporate_account">
          <el-input v-model="formData.corporate_account" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="行业" prop="industry" :error="errMsg.industry">
          <el-input v-model="formData.industry" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="经营地址" prop="address" :error="errMsg.address">
          <el-input v-model="formData.address" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" :error="errMsg.remark">
          <el-input type="textarea" :rows="6" maxlength="2000" show-word-limit v-model="formData.remark" style="width: 250px" :disabled="isView"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <div class="form-but">
      <el-button size="small" type="primary" :loading="loading" @click="saveData()" v-if="!isView">保 存</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import CustomerTag from '@/components/customer/tag';
import EmployeeSelect from '@/components/employee/select';
import uploads from '@/components/storage/uploads';
export default {
  name: 'componentsCustomerSave',
  components: {
    CustomerTag,
    EmployeeSelect,
    uploads
  },
  props: {
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        id: 0,
        name: '',
        id_card: '',
        phone: '',
        company_name: '',
        corporate_account: '',
        industry: '',
        customer_tag: '',
        employee_id: '',
        is_succ: 0,
        succ_date: '',
        remark: '',
        address: '',
        fileList: []
      },
      rules: {
        name: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
        // id_card: [
        //     { required: true, message: '请输入客户身份证', trigger: 'blur' }
        // ],
        // company_name: [
        //     { required: true, message: '请输入企业名称', trigger: 'blur' }
        // ],
        customer_tag: [{ required: true, message: '请选择客户标签', trigger: 'change' }],
        // phone: [
        //     { required: true, message: '请输入联系电话', trigger: 'blur' }
        // ],
        employee_id: [{ required: true, message: '请选择业务员', trigger: 'change' }]
      },
      errMsg: {},
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  methods: {
    //上传成功传递数据
    handleChange(file) {
      const url = process.env.VUE_APP_API_URL + '/admin/storage/file/output?filename=' + file.filePath + '&token=' + this.$token();
      const item = { types: file.type, url: url, file_path: file.filePath };
      this.formData.fileList.push(item);
    },
    //删除
    handleRemove(i) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.formData.fileList.splice(i, 1);
        })
        .catch(() => {});
    },
    //浏览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //下载
    handleDownload(url) {
      const link = document.createElement('a');
      link.href = url + '&is_dow=1';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    //父页面传数据
    setData(id) {
      this.formData.id = id;
      this.getData();
      this.initErrMsg();
      this.$refs.formRef.clearValidate();
    },
    // 获取数据
    async getData() {
      await this.$api.customer.info({ id: this.formData.id }).then(res => {
        if (res.code == 200 && res.data) {
          this.formData = res.data;
          let fileList = [];
          res.data.fileList.forEach(file => {
            if (file.file_path) {
              const url = process.env.VUE_APP_API_URL + '/admin/storage/file/output?filename=' + file.file_path + '&token=' + this.$token();
              const item = { types: file.types, url: url, file_path: file.file_path };
              fileList.push(item);
            }
          });
          this.formData.fileList = fileList;
        }
      });
    },
    // 保存数据
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (!vaild) return;
        this.initErrMsg();
        this.loading = true;
        let data = _.cloneDeep(this.formData);
        data.fileList = JSON.stringify(data.fileList);
        await this.$api.customer.save(data).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$emit('callMethod');
          } else {
            for (let k in res.data) {
              this.errMsg[k] = res.data[k];
            }
          }
        });
      });
    },
    //初始化错误信息对象
    initErrMsg() {
      this.errMsg = {};
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '');
      });
    }
  }
};
</script>
<style scoped>
.thumbnail-container {
  position: relative;
  display: inline-block;
  height: 100px;
}
.thumbnail-container:hover .action-buttons {
  display: flex;
}
.action-buttons {
  display: none;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  position: absolute;
  top: 0;
  right: 0;
}
.action-buttons .icon {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
}
.att {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background-color: #f2f6fc;
}
.att .icon {
  font-size: 48px;
  font-weight: bold;
  color: #e6a23c;
}
</style>
